import React, { Component } from "react";
import ReactDOM from "react-dom";

import { ENDPOINTS } from "../../constants/endpoints";

class RPSubscriptionPayment extends Component {
  constructor(props) {
    super(props);
    this.state = { sub_count: 1, ...props };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {}

  componentDidMount() {
    // uncomment below line to generate a image in the background
    // this.props.generateImage(this.state.product_id, this.state.setno);
  }

  amount = this.props.amount;

  render() {
    const style = {
      color: "green"
    };

    const style3 = {
      color: "white",
      fontSize: 17,
      background: "green"
    };

    return (
      <div style={style}>
        <form
          id="redirect"
          method="post"
          name="redirect"
          action="/rpsubscriptiontransactions"
        >
          <input type="hidden" name="amount" value={this.amount} />
          <input type="hidden" name="sub_count" value={this.props.sub_count} />
          <input type="hidden" name="sub_id" value={this.props.sub_id} />
          <input type="hidden" name="price" value={this.props.price} />
          <input
            type="hidden"
            name="additional_users_flg"
            value={this.props.additional_users_flg}
          />
          <input
            type="hidden"
            name="renewal_flg"
            value={this.props.renewal_flg}
          />
          <button type="submit" style={style3} className="btn btn-success">
            Razorpay Checkout
          </button>
        </form>
      </div>
    );
  }
}

export default RPSubscriptionPayment;
